// anniversary sale copy code js
document.addEventListener("DOMContentLoaded", function () {
  const copyButtons = document.querySelectorAll(".copy-btn, .copy-btn-mobile");

  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      let codeText = "";

      if (this.classList.contains("copy-btn")) {
        const codeElement = this.previousElementSibling; // span
        codeText = codeElement.textContent || codeElement.innerText;
      } else {
        // For mobile
        const parent = this.closest(".discount");
        const span = parent.querySelector(".code span");
        codeText = span.textContent || span.innerText;
      }

      navigator.clipboard
        .writeText(codeText.trim())
        .then(() => {
          const originalText = this.textContent;
          this.textContent = "Copied!";
          setTimeout(() => {
            this.textContent = originalText;
          }, 2000);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          alert("Failed to copy code to clipboard");
        });
    });
  });
});
